import { useContext, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchDialog from "../../../../patterns/modals/SearchDialog";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import useClienteController from "../controllers/ClienteController";
import { ClienteContext } from "../contexts/ClienteContext";
import Btn from "../../../../components/buttons/Btn";
import { HeaderAccordion } from "../styles/Cliente";
import Chip from "../../../../components/basics/Chip";

export default function AccordionClienteInfoComercial() {
  const {
    salesman,
    setSalesman,
    commercialPartner,
    setCommercialPartner,
    defaultPayment,
    setDefaultPayment,
    typePayment,
    setTypePayment,
    defaultDiscount,
    setDefaultDiscount,
    commercialRegionSelect,
    setCommercialRegionSelect,

    otherShippingCompany,

    expanded,
    listSalesMan,
    listCommercialRegion,
    listCommercialPartner,
    listDefaultPayment,
    listTypePayment,
    loadingInputs,
    errors,
    invertDiscount,
    setInvertDiscount,
  } = useContext(ClienteContext);
  const {
    handleChangeOpenAcordion,
    handleSearchSelectShippingCompany,
    handleDialogShippingCompany,
  } = useClienteController();

  const [modalTransportadorOpen, setModalTransportadorOpen] = useState(false);

  const columnsTranspSearch = [
    {
      label: "CÓD.",
      id: "id",
    },
    {
      label: "Transportadora",
      id: "razao",
      align: "center",
      style: { minWidth: 400 },
    },
    {
      label: "CPF/CNPJ",
      id: "cnpj_cpf",
      align: "center",
      style: { minWidth: 150 },
    },
    {
      label: "Endereço",
      id: "endereco",
      align: "center",
      style: { minWidth: 280 },
    },
    {
      label: "Bairro",
      id: "bairro",
      align: "center",
      style: { minWidth: 200 },
    },
    {
      label: "Cidade",
      id: "cidade",
      align: "center",
      style: { minWidth: 200 },
    },
    {
      label: "Cep",
      id: "cep",
      align: "center",
      style: { minWidth: 150 },
    },
  ];

  return (
    <>
      {modalTransportadorOpen && (
        <SearchDialog
          open={modalTransportadorOpen}
          setOpen={setModalTransportadorOpen}
          columns={columnsTranspSearch}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleDialogShippingCompany}
          route="prouser/transportadoras/v1"
          title="TRANSPORTADORA"
          filter="razao,id"
          include="estado"
        />
      )}
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.infoBusiness || false}
          onChange={() => handleChangeOpenAcordion("infoBusiness")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    label="INFORMAÇÕES COMERCIAIS"
                    bgcolor={
                      !expanded.infoBusiness &&
                      errors.accordions &&
                      errors.accordions.includes("infoBusiness")
                        ? "red"
                        : "default"
                    }
                    textcolor={
                      !expanded.infoBusiness &&
                      errors.accordions &&
                      errors.accordions.includes("infoBusiness")
                        ? "white"
                        : "default"
                    }
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <SelectErp
                  loading={loadingInputs.listSalesMan || false}
                  helperText={errors.salesman || ""}
                  error={errors.salesman ? true : false}
                  label="Vendedor"
                  value={salesman}
                  setValue={setSalesman}
                  optionsList={listSalesMan}
                  descriptionField="nomevendedor"
                />
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <SelectErp
                  loading={loadingInputs.listCommercialPartner || false}
                  helperText={errors.commercialPartner || ""}
                  error={errors.commercialPartner ? true : false}
                  label="Parceiro Comercial"
                  value={commercialPartner}
                  setValue={setCommercialPartner}
                  optionsList={listCommercialPartner}
                  descriptionField="nome"
                />
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <SelectErp
                  loading={loadingInputs.listDefaultPayment || false}
                  helperText={errors.defaultPayment || ""}
                  error={errors.defaultPayment ? true : false}
                  label="Tipo de Pagamento"
                  value={defaultPayment}
                  setValue={setDefaultPayment}
                  optionsList={listDefaultPayment}
                  descriptionField="descricao"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <SelectErp
                  loading={loadingInputs.listTypePayment || false}
                  helperText={errors.typePayment || ""}
                  error={errors.typePayment ? true : false}
                  label="Forma de Pagamento"
                  value={typePayment}
                  setValue={setTypePayment}
                  optionsList={listTypePayment}
                  descriptionField="descricao"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  label="Desconto Padrão"
                  maxLength={6}
                  value={defaultDiscount}
                  setValue={setDefaultDiscount}
                  mask="decimal"
                />
              </Grid>

              <Grid item lg={4} md={12} sm={12} xs={12}>
                <SearchSelect
                  descriptionField="razao"
                  variant="standard"
                  value={otherShippingCompany}
                  onChange={handleSearchSelectShippingCompany}
                  label="Transportadora"
                  route="prouser/transportadoras/v1"
                  include="estado"
                  filter="razao"
                  customChange
                />
              </Grid>
              <Grid item>
                <Btn
                  onClick={() => {
                    setModalTransportadorOpen(true);
                  }}
                  label={<Icon>search</Icon>}
                  style={{ height: "100%" }}
                />
              </Grid>

              <Grid item lg={4} md={12} sm={12} xs={12}>
                <SelectErp
                  loading={loadingInputs.listCommercialRegion || false}
                  label="Região Comercial"
                  value={commercialRegionSelect}
                  setValue={setCommercialRegionSelect}
                  optionsList={listCommercialRegion}
                  descriptionField="descricao"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  label="DI"
                  maxLength={6}
                  value={invertDiscount}
                  setValue={setInvertDiscount}
                  mask="decimal"
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
